import { render, staticRenderFns } from "./PxInputLogo.vue?vue&type=template&id=1dbe36af&scoped=true&"
import script from "./PxInputLogo.vue?vue&type=script&lang=js&"
export * from "./PxInputLogo.vue?vue&type=script&lang=js&"
import style0 from "./PxInputLogo.vue?vue&type=style&index=0&id=1dbe36af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbe36af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
